import { missingRequired, REQUIRED_FIELDS, isRequired, type FieldProblem, type RequiredEntity, type RequiredFieldDefinition } from "@szerviz/core";
import { useTranslation } from "react-i18next";
import { useApp } from "../context";

/** Required-field state of a form, following the workshop's settings. */
export function useRequired(entity: RequiredEntity, input: object, touched: boolean) {
  const { workshop } = useApp();
  const missing = missingRequired(entity, input as never, workshop.requiredFields);
  const isReq = (field: string) => {
    const d = REQUIRED_FIELDS.find((x) => x.entity === entity && x.field === field);
    return d ? isRequired(d, workshop.requiredFields) : false;
  };
  const missingField = (field: string) => touched && missing.some((d) => d.field === field || (d.field === "phoneAny" && (field === "phone" || field === "mobile")));
  return { missing, isReq, missingField };
}

/** Under the save button: what is still missing, so the grey button explains itself. */
export function MissingNote({ missing }: { missing: RequiredFieldDefinition[] }) {
  const { t } = useTranslation();
  if (missing.length === 0) return null;
  return (
    <p className="missing" role="status">
      {t("required.stillMissing", { fields: missing.map((d) => t(d.labelKey)).join(", ") })}
    </p>
  );
}

/** Under the save button: filled fields that cannot be right, each with how to fix it. */
export function ProblemNote({ problems }: { problems: FieldProblem[] }) {
  const { t } = useTranslation();
  if (problems.length === 0) return null;
  return (
    <ul className="missing" role="status">
      {problems.map((p) => (
        <li key={p.field}>{t(p.messageKey, p.params as Record<string, string>)}</li>
      ))}
    </ul>
  );
}
